<template>
  <alert-container
    border="left"
    class="lg-how-it-works body-2 pl-6 mb-0"
  >
    <strong>Let’s find you cover!</strong> We work with a range of {{ productTitleText }} specialists to help find you the right level of cover.
    <ul>
      <li
        v-for="(message, index) in howItWorksMessages"
        :key="index"
      >
        <v-icon
          color="primary"
          size="22"
        >
          mdi-check-circle-outline
        </v-icon>
        <span v-html="message" />
      </li>
    </ul>
  </alert-container>
</template>

<script>
import AlertContainer from '@/components/HeadlineContainers/AlertContainer';

export default {
  name: 'how-it-works-redesign',
  components: {
    AlertContainer,
  },
  inject: [
    'productName',
    'formMetadata',
  ],
  computed: {
    productTitleText () {
      if (this.productName === 'incomeprotection') return this.formMetadata.productTitle.toLowerCase();
      return this.formMetadata.productTitle.toLowerCase() + ' insurance';
    },
    howItWorksMessages () {
      return [
        'Complete our <strong>short form</strong>',
        `We’ll <strong>match your requirements</strong> with one of our specialist ${this.productTitleText} advisers`,
        `They'll <strong>call you</strong> to discuss your ${this.productTitleText} options and <strong>compare policies</strong> from the main UK providers (e.g. Aviva, Vitality, Zurich and Legal & General)`,
        'Compare and <strong>choose a policy</strong> that suits you',
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
  .lg-how-it-works {
    border: 1px solid $clr-heather;

    ul {
      list-style-type: none;
      padding: 0;

      span {
        margin-left: 4px;
      }
    }
  }
</style>
